import { HttpClient, HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject, filter, finalize, first, map, Observable, Subject, Subscription, take, takeUntil } from 'rxjs';
import { LgvUserService, NotificationService } from '../../core/core.module';
import { LgvLoanApplicationService } from '../../core/services/lgv-loan-application.service';
import { LgvDataHelper } from '../../core/utility/lgv-data-helper';
import { LgvLoanApp } from '../../data-models/lgv-loan-application.model';
import { environment as env } from '../../../environments/environment';
import { Http2ServerResponse } from 'http2';

@Component({
    selector: 'lgv-loan-app-task-modal',
    templateUrl: './loan-app-task-modal.component.html',
    styleUrls: ['./loan-app-task-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoanAppTaskModalComponent implements OnInit, OnDestroy {

    onDestroy$ = new Subject();
    isReady: boolean = false;
    loanAppId: string;
    clientId: string;
    mode: string;
    isReturnOnly = false;
    selectedFile: [] = [];
    selectedFileName: string[];
    isLoading$ = new BehaviorSubject(false);

    taskList: LgvLoanApp.Task[] = [];
    filteredTaskList: LgvLoanApp.Task[] = [];
    //_selectedTask: LgvLoanApp.Task = null;
    //selectedTask$ = new BehaviorSubject(this._selectedTask);
    selectedTask: LgvLoanApp.Task = null;

    isUploading$ = new BehaviorSubject(false);
    imageChangedEvent: any = '';
    isCreditReportSelected$ = new BehaviorSubject(false);

    uploadProgress$ = new BehaviorSubject(0);
    //uploadProgress: number = 0;
    uploadSub: Subscription;

    get isAddMode(): boolean { return this.mode === 'addTask'; }
    get isEditMode(): boolean { return this.mode === 'editTask'; }
    get isUploadDocumentMode(): boolean { return this.mode === 'uploadDocument'; }
    get readyToSubmit(): boolean { return (this.isUploadDocumentMode && !!this.selectedFile) || (!this.isUploadDocumentMode && this._taskForm?.valid) }

    //#region Task Form
    _taskForm: UntypedFormGroup;

    get typeFG(): AbstractControl { return this._taskForm.get('type'); }
    get itemFG(): AbstractControl { return this._taskForm.get('item'); }
    get creditReportTypeField(): AbstractControl { return this._taskForm.get('creditReportType').get('id'); }

    get typeIdField(): AbstractControl { return this.typeFG.get('id'); }
    get typeNameField(): AbstractControl { return this.typeFG.get('name'); }
    get itemIdField(): AbstractControl { return this.itemFG.get('id'); }
    get itemNameField(): AbstractControl { return this.itemFG.get('name'); }
    get nameField(): AbstractControl { return this._taskForm.get('name'); }
    get descriptionField(): AbstractControl { return this._taskForm.get('description'); }

    taskSubmissionQueue = [];

    //#endregion Task Form

    constructor(
        private http: HttpClient,
        private fb: UntypedFormBuilder,
        public notificationSvc: NotificationService,
        public lgvDataHlpr: LgvDataHelper,
        public dialogRef: MatDialogRef<LoanAppTaskModalComponent>,
        public lgvUserSvc: LgvUserService,
        public matDialog: MatDialog,
        public lgvLoanAppSvc: LgvLoanApplicationService,
        @Inject(MAT_DIALOG_DATA) public data: any)
    {
        this.clientId = data.clientId;
        this.loanAppId = data.loanAppId;
        this.mode = data.mode;
        this.taskList = data.taskList ?? [];
        this.selectedTask = data.taskItem;
        this.isReturnOnly = data.isReturnOnly ?? false;
        this.selectedFile = data.selectedFile;

        //if (this.taskList && this.taskList.length > 0 && !this.selectedTask) {
        //    this.selectedTask = this.taskList[0];
        //}


        console.log('taskItem:');
        console.log(this.selectedTask);
    }

    ngOnInit(): void {
        
        this.lgvLoanAppSvc.assignableTaskTypes$.pipe(filter(f => f !== null), take(1)).subscribe(x => {
            this.initTaskForm();
            this.isReady = true;
        });
    }

    ngOnDestroy() {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    initTaskForm() {
        // console.log('Init Task Form:');
        // console.log('this.taskItem?.type?.id ?? null');
        // console.log(this.selectedTask?.item?.id ?? null);
        // console.log(this.lgvLoanAppSvc.taskItems$.value);
        if (this.selectedTask?.name == 'Loan Application (1003)') {
            this.selectedTask = null;
        }

        this._taskForm = this.fb.group({
            id: [this.selectedTask?.id ?? null, []],
            loanApplicationId: [this.loanAppId, []],
            updatedBy: [null, []],
            name: [this.selectedTask?.name ?? null, [Validators.required]],
            description: [this.selectedTask?.name ?? null, [Validators.required]],
            displayOrder: [0, []],
            type: this.fb.group({
                id: [this.selectedTask?.type?.id.toUpperCase() ?? null, [Validators.required]],
                name: [this.selectedTask?.name ?? null, []],
            }),
            item: this.fb.group({
                id: [this.selectedTask?.item?.id.toUpperCase() ?? null, [Validators.required]],
                name: [null, []],
            }),
            creditReportType: this.fb.group({
                id: [null],
                name: [null]
            }),
            //document: this.fb.group({
            //    id: [this.taskItem?.type?.id ?? null, [Validators.required]],
            //    name: [this.taskItem?.type?.name ?? null, [Validators.required]],
            //    externalId: [null, []],
            //}),
            
            //status: this.fb.group({
            //    id: [null, []],
            //    name: [null, []],
            //}),

        });

        this.typeIdField.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe((x) => {
            this.nameField.setValue(null);
            this.descriptionField.setValue(null);

            if (!!x) {
                this.isCreditReportSelected$.next((x === 'E599535A-03D2-EE11-85F7-6045BD020C58'));
                
                // update the default document name when the selected task / document changes.
                this.lgvLoanAppSvc.getTypeById$(x).pipe(first(f => f !== null), takeUntil(this.onDestroy$)).subscribe(x => {
                    this.typeNameField.setValue(x.name);
                });

                // if there is just one doc type (item) available, select it...
                this.lgvLoanAppSvc.taskItemsForType$(x).pipe(take(1)).subscribe(taskItems => {
                    if (taskItems && taskItems.length === 1) {
                        this.itemIdField.setValue(taskItems[0].id);
                    }
                });
            }
            else {
                this.typeNameField.setValue(null);
            }
        });

        this.itemIdField.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe((x) => {
            this.isCreditReportSelected$.next((x === '31c581f0-b292-ef11-8474-000d3a58cdb7'));
            if (!this.isUploading$.value) {
                if (!!x) {
                    // update the default document name when the selected task / document changes.
                    this.lgvLoanAppSvc.getTaskById$(x).pipe(first(f => !!f), takeUntil(this.onDestroy$)).subscribe(t => {
                        this.nameField.setValue(t.name);
                        this.descriptionField.setValue(t.description);
                        this.selectedTask =  t;
                    });
                }
                else {
                    this.nameField.setValue(null);
                    this.descriptionField.setValue(null);
                }
            }
        });

        

        this.isCreditReportSelected$.pipe(takeUntil(this.onDestroy$)).subscribe((isCreditReportSelected) => {
            if (isCreditReportSelected) {
                this.creditReportTypeField.addValidators([Validators.required]);
                this._taskForm.updateValueAndValidity();
            } else {
                this.creditReportTypeField.clearValidators();
                this.creditReportTypeField.setErrors(null);
                this._taskForm.updateValueAndValidity();
            }
        });

        this.creditReportTypeField.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe(reportTypeId => {
            const creditReport = this.lgvLoanAppSvc.creditReportTypes$.value.find(rt => rt?.id == reportTypeId);
            const isBorrowerChoice = creditReport?.id === 'CBFBCFD7-3CFA-EF11-90CB-000D3A5AD2C4';
            this.nameField.setValue('Credit Report' + (isBorrowerChoice ? '' : ' - ' + creditReport?.name));
            if (isBorrowerChoice) {
                this.descriptionField.setValue(this.selectedTask?.description + ' You can select either a hard or a soft pull for this task.');
            } else {
                this.descriptionField.setValue(this.selectedTask?.description);
            }
        })
        
        if (!!this.selectedTask) {
            // add a slight delay for this to account for typeIdField.valueChanges above...
            setTimeout(() => {

                if (!this.isUploadDocumentMode) {
                    this.itemIdField.setValue(this.selectedTask.item.id);
                    this.nameField.setValue(this.selectedTask.name);
                    this.descriptionField.setValue(this.selectedTask.description);
                }
                else {

                }

            }, 500);

        }

        this.filteredTaskList = this.taskList.filter(task => task.type.name != 'Form');
    }


    onSubmit() {
        let t = this._taskForm.getRawValue();
        this.isLoading$.next(true);
        if (this.isAddMode) {
            
            if (this.isReturnOnly) {
                this.dialogRef.close(
                    {
                        action: true,
                        task: t
                    });
                return;
            }

            this.lgvLoanAppSvc.addTask(t, this.loanAppId).pipe(take(1)).subscribe(x => {
                this.isLoading$.next(false);
                this.dialogRef.close({ action: true, task: x });
            },
                (err) => {
                    this.notificationSvc.error(`There was an error adding ${t.name} to the application.`)
                }
            );
        }
        if (this.isEditMode) {
            this.lgvLoanAppSvc.updateTask(t, t.id, this.loanAppId).pipe(take(1)).subscribe(x => {
                this.isLoading$.next(false);
                this.dialogRef.close({ action: true, task: x });
            },
                (err) => {
                    this.notificationSvc.error(`There was an error adding ${t.name} to the application.`)
                }
            );
        }
        if (this.isUploadDocumentMode) {
            this.uploadSelectedFiles();
        }
    }

    onCancel() {
        this.dialogRef.close({ action: false });
    }

    //#region Upload
    fileChangeEvent(event: any): void {
        console.log(event);
        if (event?.target?.files?.length > 0) {
            const files = event.target.files;
            console.log('files:');
            console.log(files);

            this.selectedFile = files;
        }
    }

    uploadSelectedFiles() {

        for(let i =0; i<this.selectedFile.length; i ++) {

            const formData = new FormData();
            formData.append("file", this.selectedFile[i]);
            formData.append('ContentType', "form-data");

            this.isUploading$.next(true);
            let bldUrl = `${env.LgvApiBaseUrl}/loanapplications/${this.loanAppId}/tasks/${this.selectedTask.id}/documents?clientId=${this.clientId}`;

            const upload$ = this.http.post<any>(bldUrl, formData, {
                reportProgress: true,
                observe: 'events'
            })
                .pipe( finalize(() => {
                    console.log('FINALIZE');
                    this.uploadSub = null;
                    this.isUploading$.next(false);
                }));


            upload$.subscribe(event => {
                if (event.type == HttpEventType.UploadProgress) {
                    this.uploadProgress$.next(Math.round(100 * (event.loaded / (event.total *i )) ));
                    console.log(this.uploadProgress$.value);
                }
                if (event instanceof HttpResponse) {
                    if (event.statusText === "OK" && i==this.selectedFile?.length-1) {
                        this.notificationSvc.success('Document has been uploaded.');
                        this.dialogRef.close({ action: true });
                    }
                }
            },
                (err) => {
                    this.isUploading$.next(false);
                    console.log('*** Error uploading document. ***')
                    this.notificationSvc.error(`There was an error uploading your document.`)
                }
            );
        }
    }

    onTestSelection(event: any) {
        console.log('onTestSelection()');
        console.log(event);
    }

    //#endregion Upload
}
